import { useEffect, useState } from "react";
import { HeaderBodyTable, HeaderTable } from "./V2/Overview/Table";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedMenu } from "../../../redux/app/apidocs/apidocs-slice";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { nightOwl } from "react-syntax-highlighter/dist/esm/styles/prism";

export const Table = ({ columns, data }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border-collapse rounded-lg overflow-hidden">
        <thead className="bg-gray-200">
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex % 2 === 0 ? "bg-gray-50" : "bg-white"}
            >
              {Object.values(row).map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const Accordion = ({ title, icon, children, onCLick,id }) => {
  const { documentationVersion } = useSelector((state) => state.apidocs);
  const [isOpen, setIsOpen] = useState(true);

  console.log("isOpen====>", isOpen);
  console.log("title====>", title);


  return (
    <div
      className={`rounded-md mb-2 h-auto overflow-y-scroll scrollbar`}
      onClick={onCLick}
    >
      <div
        className={`flex justify-between items-center p-4 cursor-pointer ${documentationVersion===id?"bg-red-100":""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {icon ? (
          <>
            <div className="flex items-center space-x-2 ">
              {icon && <span className="mr-2">{icon}</span>}
              <h2 className="text-base font-medium">{title}</h2>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-base font-medium">{title}</h2>
          </>
        )}
        <div
          className={`transform transition-transform duration-500 ease-out ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>
      <div
        className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
          isOpen ? "" : "max-h-0"
        }`}
      >
        <div className="py-2 pl-5 pr-4 space-y-1 ">{children}</div>
      </div>
    </div>
  );
};

export const SubAccordion = ({ title, icon, children, isOpenSubmodal, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isOpenSubmodal);
  }, [isOpenSubmodal]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="rounded-md mb-2">
      <a
        href={`#${id}`}
        className="flex justify-between items-center py-4 cursor-pointer"
        onClick={handleToggle}
      >
        {icon ? (
          <>
            <div className="flex items-center space-x-2">
              {icon && <span className="mr-2">{icon}</span>}
              <h2 className="text-base">{title}</h2>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-base">{title}</h2>
          </>
        )}

        <div
          className={`transform transition-transform duration-500 ease-out ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </a>
      <div
        className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
          isOpen ? "max-h-screen" : "max-h-0"
        }`}
      >
        <div
          className=" pl-2 pr-2 space-y-1 rounded-xl"
          style={{ marginBottom: "0px" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export const SubAccordionCode = ({
  title,
  icon,
  children,
  isOpenSubmodal,
  id,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  // useEffect(() => {
  //   setIsOpen(isOpenSubmodal);
  // }, [isOpenSubmodal]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="rounded-md mb-2 ">
      <a
        href={`#${id}`}
        className="flex justify-between items-center py-4 cursor-pointer px-6 bg-gray-200 text-gray-500 rounded-md"
        onClick={handleToggle}
      >
        {icon ? (
          <>
            <div className="flex items-center space-x-2">
              {icon && <span className="mr-2">{icon}</span>}
              <h2 className="text-base">{title}</h2>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-base">{title}</h2>
          </>
        )}

        <div
          className={`transform transition-transform duration-500 ease-out ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </a>
      <div
        className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
          isOpen ? "max-h-screen" : "max-h-0"
        }`}
      >
        <div
          className=" pl-2 pr-2 space-y-1 rounded-xl"
          style={{ marginBottom: "0px" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export const SubMenu = ({ title, icon, onClick, id }) => {
  const dispatch = useDispatch();
  const { selectedMenu } = useSelector((state) => state.apidocs);
  return (
    <div
      onClick={() => {
        dispatch(setSelectedMenu({ selectedMenu: id }));
      }}
    >
      <a
        href={`#${id}`}
        className={`flex space-x-4 py-3 px-2 rounded-lg text-base cursor-pointer items-center ${
          selectedMenu === id ? "bg-red-50 font-medium" : ""
        }`}
        onClick={onClick}
      >
        <div>{icon}</div>
        <div>{title}</div>
      </a>
    </div>
  );
};

export const SubMenuTwo = ({ title, onClick, reqType, id }) => {
  const dispatch = useDispatch();
  const { selectedMenu } = useSelector((state) => state.apidocs);
  return (
    <div
      onClick={() => {
        dispatch(setSelectedMenu({ selectedMenu: id }));
      }}
    >
      <a
        href={`#${id}`}
        className={`flex space-x-4 py-3 px-2 rounded-lg text-base cursor-pointer items-center ${
          selectedMenu === id ? "bg-red-50 font-medium" : ""
        }`}
        onClick={onClick}
      >
        <div
          className={`text-xs font-semibold ${
            reqType === "POST"
              ? "bg-sky-500"
              : reqType === "GET"
              ? "bg-orange-500"
              : reqType === "PATCH"
              ? "bg-yellow-500"
              : reqType === "DELETE"
              ? "bg-red-700"
              : ""
          } text-white w-16 h-7 flex justify-center items-center rounded-lg`}
        >
          {reqType}
        </div>

        <div className="text-sm">{title}</div>
      </a>
    </div>
  );
};

export const DescMain = ({ header, children, id }) => {
  return (
    <div className="space-y-4 mb-2 font-sans" id={id}>
      <div className="text-xl font-semibold text-slate-800 border-b-[1px] pb-2 border-slate-400">
        {header}
      </div>
      <div>{children}</div>
    </div>
  );
};

export const SubDescMain = ({ header, children, id }) => {
  return (
    <div className="space-y-4 mb-2 font-sans px-2" id={id}>
      <div className="text-base font-semibold text-slate-800 border-b-[1px] pb-2 border-slate-300 pt-5">
        {header}
      </div>
      <div className="space-y-5">{children}</div>
    </div>
  );
};

export const RequestUrl = ({ title, reqType }) => {
  return (
    <div>
      <div className="xl:flex xl:space-x-4 py-3 rounded-lg text-base cursor-pointer items-center">
        <div className="flex items-center space-x-2 mb-2 xl:mb-0">
          <div>Endpoint:</div>
          <div
            className={`text-xs font-semibold ${
              reqType === "POST"
                ? "bg-sky-500"
                : reqType === "GET"
                ? "bg-orange-500"
                : reqType === "PATCH"
                ? "bg-yellow-500"
                : reqType === "DELETE"
                ? "bg-red-700"
                : ""
            } text-white w-16 h-7 flex justify-center items-center rounded-lg`}
          >
            {reqType}
          </div>
        </div>
        <div
          className={`text-sm ${
            reqType === "POST"
              ? "text-sky-600"
              : reqType === "GET"
              ? "text-orange-600"
              : reqType === "PATCH"
              ? "text-yellow-500"
              : reqType === "DELETE"
              ? "text-red-700"
              : ""
          } bg-slate-100 px-5 py-1 rounded-xl`}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export const Header = () => {
  return (
    <div>
      {/* Header */}
      <div>
        <div className="space-y-3">
          <div>{"Header :"}</div>
          <div>
            <Table columns={HeaderTable} data={HeaderBodyTable} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const BodyPara = ({
  bodyEmpty,
  bodyTabHeader,
  bodyTableValues,
  bodyPayload,
}) => {
  const requestBody = JSON.stringify(bodyPayload, null, 2);
  return (
    <div>
      {bodyEmpty ? (
        <>
          <div className={`flex space-x-3`}>
            <div>{"Body Parameter :"}</div>
            <div>Body Is Empty</div>
          </div>
        </>
      ) : (
        <>
          <div className={`space-y-3`}>
            <div>{"Body Parameter :"}</div>
            <div>
              <Table columns={bodyTabHeader} data={bodyTableValues} />
            </div>
            <div>
              <SubAccordionCode title={"Body Code"}>
                <CodeSnippet code={requestBody} />
              </SubAccordionCode>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const QueryPara = ({ queryEmpty, bodyTabHeader, bodyTableValues }) => {
  return (
    <div>
      {queryEmpty ? (
        <>
          <div className={`flex space-x-3`}>
            <div>{"Query Parameter :"}</div>
            <div>Query Is Empty</div>
          </div>
        </>
      ) : (
        <>
          <div className={`space-y-3`}>
            <div>{"Query Parameter :"}</div>
            <div>
              <Table columns={bodyTabHeader} data={bodyTableValues} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const ResponseComp = ({ responseDescription, responsePayload }) => {
  const apiResponse = JSON.stringify(responsePayload, null, 2);
  return (
    <div>
      {/* Header */}
      <div className="space-y-3">
        <div>{"Response :"}</div>
        <div className="flex">
          <div className="w-24">{"Status Code"}</div>
          <div>:</div>
          <div className="pl-2">200 </div>
        </div>
        <div className="space-y-1">
          <div className="flex">
            <div className="w-24 ">{"Description"}</div>
            <div>:</div>
          </div>
          <div className="pl-2">{responseDescription}</div>
        </div>
        <div>
          <SubAccordionCode title={"Response Code"}>
            <CodeSnippet code={apiResponse} />
          </SubAccordionCode>
        </div>
      </div>
    </div>
  );
};

export const CustomSelect = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };
  return (
    <div className="relative inline-block w-64">
      <div
        className="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:border-indigo-500 cursor-pointer"
        onClick={handleSelectClick}
      >
        {options.find((option) => option.value === value)?.label || "Select..."}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M5.293 7.293L10 12l4.707-4.707-1.414-1.414L10 9.172 6.707 5.879z" />
          </svg>
        </div>
      </div>
      {isOpen && (
        <ul className="absolute z-20 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg">
          {options.map((option) => (
            <li
              key={option.value}
              className="py-2 px-4 hover:bg-red-50 cursor-pointer text-sm"
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const CodeSnippet = ({ code }) => {
  const customStyle = {
    background: "#282c34", // Custom background color
    color: "#9CDCFE", // Custom text color
    padding: "20px", // Padding around the code block
    borderRadius: "5px", // Rounded corners for the code block
    lineHeight: "1.5", // Line height for better readability
    overflow: "auto", // Enables scrolling for overflow content
    maxHeight: "500px", // Maximum height before scrolling starts
  };
  return (
    <SyntaxHighlighter
      language="json"
      style={nightOwl}
      customStyle={customStyle}
      wrapLines={true}
      wrapLongLines={true}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export const ApiCallComponent = ({ AllCodeImplementation, title }) => {
  const [selectedLanguage, setSelectedLanguage] = useState("curl");

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const languages = [
    { value: "nodejs_Axios", label: "Node.js (Axios)" },
    { value: "python", label: "Python (Requests)" },
    { value: "go", label: "Go (Native)" },
    { value: "curl", label: "cURL" },
    { value: "php", label: "PHP (cURL)" },
  ];

  return (
    <SubAccordionCode title={"Code Examples"}>
      <div className="space-y-4">
        <h2 className="text-base font-semibold text-slate-800 border-b-[1px] pb-2 border-slate-300 pt-5">
          {`Code Examples for ${title}`}
        </h2>
        <div className="flex items-center mb-4">
          <label
            htmlFor="language"
            className="text-lg font-medium text-gray-700 mr-4"
          >
            Select Language:{" "}
          </label>
          <CustomSelect
            id="language"
            value={selectedLanguage}
            onChange={handleLanguageChange}
            options={languages}
          />
        </div>
        <div>
          <CodeSnippet
            code={AllCodeImplementation[selectedLanguage]}
            language={selectedLanguage.split("_")[0]}
          />
        </div>
      </div>
    </SubAccordionCode>
  );
};
